const isMacOrIos = () => {
  // @ts-expect-error
  if (navigator.userAgentData) {
    // @ts-expect-error
    return navigator.userAgentData.platform === 'macOS'
  }
  return (
    /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) ||
    /(iPhone|iPod|iPad)/i.test(navigator.platform)
  )
}

export const keyboardKeyTips = () => {
  const commandCtrl = isMacOrIos() ? '⌘' : 'Ctrl'

  return { commandCtrl }
}

export const keyboardKeys = () => {
  const commandCtrl = isMacOrIos() ? 'Meta' : 'Control'
  return {
    commandCtrl,
    space: ' ',
    shift: 'Shift',
  }
}
